import { useEffect, useState, useMemo } from "react";

import { makeStyles, Typography } from "@material-ui/core";

import { api } from "../../../../services/api";
import { POWER_ASSETS_COLORS } from "../../constants";
import { GRAPH_UNITS } from "../../../dashboard/constants";
import { ShaDowBox } from "../../../../components/boxes/ShadowBox";
import { PieChart } from "../../../../components/charts/PieChart";
import { PieLegends } from "../../../../components/charts/PieLegends";
import { requestDateFormat, capitalize } from "../../../../services/utils";
import { NoDataCard } from "../../../../components/parts";

const useStyles = makeStyles((theme) => ({
  box: {
    padding: `${theme.spacing(3)}px ${theme.spacing(3.5)}px`,
  },
}));

export const RevenuesTotal = ({ period, startDate, endDate, graphUnit }) => {
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [rawData, setRawData] = useState([]);

  const title = "Power revenues - Total";

  useEffect(() => {
    if (rawData) {
      const data = rawData.map((item) => ({
        name: capitalize(item.name),
        value: graphUnit === GRAPH_UNITS.kwh ? item.kwh_value : item.value,
        legendValue: graphUnit === GRAPH_UNITS.kwh ? item.kwh_value : item.value,
        displayValue: graphUnit === GRAPH_UNITS.kwh ? item.kwh_value : item.value,
        key: item.name,
      }));
      setData(data);
    }
  }, [rawData, graphUnit]);

  useEffect(() => {
    const getData = (url) => {
      api.get(url).then((resp) => setRawData(resp.data.results));
    };

    let url = "/praas/v1/power-revenue/overview/total/";
    if (period.name === "RANGE" && endDate) {
      url += `?from_date=${requestDateFormat(startDate)}&to_date=${requestDateFormat(endDate)}`;
      getData(url);
    } else if (["YTD", "Acc.", "20Y"].includes(period.name)) {
      url += `?date_filter=${period.filter}`;
      getData(url);
    }
  }, [period, startDate, endDate]);

  const getData = useMemo(() => {
    return data.filter((val) => val.value);
  }, [data]);

  return (
    <ShaDowBox style={{ width: "100%" }}>
      {data.length ? (
        <div className={classes.box} id="revenues-total">
          <Typography variant="h4">{title}</Typography>
          <>
            <PieChart
              data={getData}
              colors={POWER_ASSETS_COLORS}
              name={graphUnit === GRAPH_UNITS.kwh ? "PowerRevenueKWH" : "PowerRevenue"}
            />
            <PieLegends data={data} colors={POWER_ASSETS_COLORS} unit={graphUnit} />
          </>
        </div>
      ) : (
        <NoDataCard title={title} type="pie" />
      )}
    </ShaDowBox>
  );
};
